export enum Season {
  None = 'N/A',
  Winter = 'Winter',
  Summer = 'Summer',
}

export enum PSO {
  Peak = 'Peak',
  Standard = 'Standard',
  OffPeak = 'Off-Peak',
}

export enum PSOShort {
  Peak = 'P',
  Standard = 'S',
  OffPeak = 'O',
}


export enum Days {
  Weekdays = 'Weekdays',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum ChargeName {
  Energy = 'Energy Charge',
  Basic = 'Basic Charge',
  Demand = 'Demand Charge',
  Access = 'Access Charge',
  Service = 'Service Charge',
  Capacity = 'Capacity Charge',
  Reactive = 'Reactive Charge',
  Legacy = 'Legacy Charge',
  NetworkDemand = 'Network Demand Charge',
  Generation = 'Generation Charge',
  Electrification = 'Electrification Charge',
  Affordability = 'Affordability Charge',
  Ancillary = 'Ancillary Charge',
  CreditRev = 'Credit Reverse Charge',
}


